import { useFeatureFlag } from "@squide/firefly";
import { parseAsString, useQueryState } from "nuqs";

const segmentIdParser = parseAsString.withOptions({ history: "replace", shallow: false });

export function useTeamSegment() {
    const isSegmentsEnabled = useFeatureFlag("enable-team-segments", false);
    const [segmentId, setSegmentId] = useQueryState("team-segment", segmentIdParser);

    return [isSegmentsEnabled ? segmentId : null, setSegmentId] as const;
}
